import Vue from 'vue';
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
let base = '';
let alertType = true; // 用作限制只弹窗一次1
let beOverdue = true; // 用作token过期弹窗
let publicURL;
let dyURL;
let yphURL;
const isDev = process.env.NODE_ENV === 'development';
let commonUrl = '';
let dzpublic = '';
import { localToken } from '@tiktok/config/index';
let token = isDev ? localToken : localStorage.getItem('accessToken') || localStorage.getItem('token');
if (isDev) {
    localStorage.setItem('token', token);
    localStorage.setItem('accessToken', token);
}
if (isDev || location.href.indexOf('test-douyin.') > -1) {
    base = 'https://test-api.fjdaze.com/tiktok'; // 测试
    // base = "https://api.fjdaze.com/tiktok/"; // 正式
    publicURL = 'https://test-api.fjdaze.com/shopmanager';
    dyURL = 'https://test-api.fjdaze.com/tiktok';
    commonUrl = 'https://test-api.fjdaze.com';
    dzpublic = 'https://dkd-test.dazeyun.com/dzpublic';
    yphURL = 'https://dkd-test.dazeyun.com/distribution';
} else {
    base = 'https://api.fjdaze.com/tiktok/';
    publicURL = 'https://api.fjdaze.com/shopmanager';
    dyURL = 'https://api.fjdaze.com/tiktok/';
    commonUrl = 'https://api.fjdaze.com';
    dzpublic = 'https://api.fjdaze.com/dzpublic';
    yphURL = 'https://api.fjdaze.com/dkddistr/distribution';
}

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';
function setToken(val) {
    token = val;
    Vue.prototype.$token = val;
}

const ajax = axios.create({ baseURL: base, timeout: 0 });

// 添加请求拦截器
ajax.interceptors.request.use(function (config) {
    config.beginTime = new Date().getTime();
    if (!token) {
        token = localStorage.getItem('accessToken');
    }

    if (token) {
        config.headers.common['token'] = token;
    }
    if (config.method === 'get') {
        config.data = { unused: 0 };
    }
    if (config.data) {
        if (!config.isFrom) {
            if (config.data.isFrom) {
                config.isFrom = config.data.isFrom;
            } else if (config.params && config.params.isFrom) {
                config.isFrom = config.params.isFrom;
            } else {
                config.isFrom = '';
            }
        }
        //同步商品999不提示
        if (config.data.noMsg) {
            config.noMsg = config.data.noMsg;
        } else {
            config.noMsg = '';
        }
    }
    return config;
});

// 添加响应拦截器
ajax.interceptors.response.use(
    function (res) {
        // 对响应数据做点什么
        const data = res.data;
        const rt = new Date().getTime() - res.config.beginTime; // 接口耗时
        if (rt > 2000 || res.data.code !== 200) {
            window._dzPoint &&
                window._dzPoint.push({
                    t: res.data.code === 200 ? 'request' : 'requestCodeError',
                    rc: res.status, // 请求状态码
                    rt: rt, // 接口耗时
                    ru: res.config.url, // 请求的地址
                    ec: res.data.code, // 后端返回的code
                    em: res.data.msg, // 后端返回的错误信息
                    c: JSON.stringify({
                        method: res.config.method, // 请求方式
                        data: res.config.data, // 请求参数
                        params: res.config.params, // 请求参数
                    }),
                });
        }
        // eslint-disable-next-line no-prototype-builtins
        if (data.hasOwnProperty('code')) {
            switch (data.code) {
                case 200:
                    if (res.config.isFrom === 'assembly') {
                        return res.data.result;
                    } else {
                        return data;
                    }
                case 5000:
                    Message({
                        type: 'error',
                        message: data.msg,
                    });
                    return data;
                case 4000:
                    if (beOverdue) {
                        MessageBox.confirm('token已过期', '提示', {
                            confirmButtonText: '确定',
                            showCancelButton: false,
                            type: 'warning',
                        })
                            .then(() => {
                                beOverdue = true;
                                window.open('http://occ.fjdaze.com/auth/login?appkey=6840999917110199815');
                            })
                            .catch(function () {
                                beOverdue = true;
                            });
                    }
                    beOverdue = false;
                    setTimeout(() => {
                        if (process.env.NODE_ENV === 'development') {
                            return;
                        }
                        if (data.msg.indexOf('access_token') > -1 || data.msg.indexOf('过期') > -1) {
                            isDev && (window.open = 'http://occ.fjdaze.com/auth/login?appkey=6840999917110199815');
                        }
                    }, 2000);
                    return data;
                case 4010:
                    if (alertType) {
                        MessageBox.confirm('您的订单服务时间已到期,需订购后才能使用,请先订购', '提示', {
                            confirmButtonText: '立即订购',
                            showCancelButton: false,
                            type: 'warning',
                        })
                            .then(() => {
                                alertType = true;
                                window.open('https://fuwu.jinritemai.com/detail?from=tab&service_id=97');
                            })
                            .catch(function () {
                                alertType = true;
                            });
                    }
                    alertType = false;
                    return data;
                default:
                    if (res.config.noMsg === 'noMsg') {
                        return data;
                    } else {
                        Message({
                            type: 'error',
                            message: data.msg,
                            customClass: 'messageIndex',
                        });
                    }
                    if (res.config.isFrom === 'assembly') {
                        return Promise.reject(res.data);
                    } else {
                        return data;
                    }
            }
        } else {
            return data;
        }
    },
    function (error) {
        Message({
            type: 'error',
            message: '网络错误',
        });
        return Promise.reject(error);
    }
);

Vue.prototype.$isDev = isDev;
Vue.prototype.$token = token || localStorage.getItem('accessToken') || localStorage.getItem('token');
Vue.prototype.$ajax = ajax;
Vue.prototype.$publicURL = publicURL;
Vue.prototype.$baseUrl = base;
Vue.prototype.$dyURL = dyURL;
Vue.prototype.$commonUrl = commonUrl;
Vue.prototype.$dzpublic = dzpublic;
Vue.prototype.$yphURL = yphURL;

export { ajax, isDev, setToken, publicURL };
